var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolButton',{class:{ 'toggled': _vm.Editor.isActive('italic') },attrs:{"Editor":_vm.Editor,"KnownIcon":"Italic"},on:{"ToolClick":function($event){_vm.Editor.chain().focus().toggleItalic().run()}}})}
var staticRenderFns = []

export { render, staticRenderFns }